import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { ContainedButton, TextButton, Dialog } from '@shared/components';
import { useFormContext } from 'react-hook-form';
import { ExportSchema } from './exportSchema';
import { ExportDialogForm } from './ExportDialogForm';
import { useState } from 'react';

export const ExportFileTypes = {
  Vilma: 'vilma',
  Csv: 'csv',
} as const;

export type ExportFileType = (typeof ExportFileTypes)[keyof typeof ExportFileTypes];

type VilmaVersion = 'VILMA_27' | 'VILMA_28';
export interface ExportOptions {
  vilmaVersion?: VilmaVersion;
  futureDays?: number;
}
interface Props {
  isLoading: boolean;
  defaultExportValues?: ExportOptions;
  onSubmit: (data: ExportSchema, csv: boolean) => void;
  onClose: () => void;
}

export const ExportDialog = ({ isLoading, defaultExportValues, onSubmit, onClose }: Props) => {
  const t = useAppTFunction();

  const [fileType, setFileType] = useState<ExportFileType>(ExportFileTypes.Vilma);

  const { handleSubmit, reset } = useFormContext<ExportSchema>();

  const handleClick = (data: ExportSchema) => onSubmit(data, fileType === ExportFileTypes.Csv);

  const handleClose = () => {
    onClose();
    reset();
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <form>
        <DialogTitle sx={{ pb: 1 }}>{t('export.exportFile')}</DialogTitle>

        <DialogContent>
          <ExportDialogForm
            fileType={fileType}
            defaultExportValues={defaultExportValues}
            setFileType={setFileType}
          />
        </DialogContent>

        <DialogActions>
          <TextButton onClick={handleClose} disabled={isLoading} size="small">
            {t('common.cancel')}
          </TextButton>

          <ContainedButton
            type="submit"
            color="secondary"
            size="small"
            loading={isLoading}
            onClick={handleSubmit(handleClick)}
          >
            {t('export.download')}
          </ContainedButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};
